import { ValueOf } from './utils';

export type DateRageType = {
  startDate: string | null;
  endDate: string | null;
};

/**
 *  날짜 포맷
 */
export const DATE_FORMAT = {
  /**
   *  FULL 형태의 날짜 형식
   */
  FULL_KOREAN_FORMAT: 'YYYY년 MM월 DD일 HH시 mm분 ss초',
  /**
   *  YYYY년 MM월 DD일 형태의 날짜 형식
   */
  YMD_KOREAN_FORMAT: 'YYYY년 MM월 DD일',
  /**
   *  YYYY년 MM월 형태의 날짜 형식
   */
  YM_KOREAN_FORMAT: 'YYYY년 MM월',
  /**
   *  FULL DASH 형태의 날짜 형식
   */
  FULL_DASH_FORMAT: 'YYYY-MM-DD HH:mm:ss',
  /**
   *  년-월-일 시:분 형태의 날짜 형식
   */
  YMD_HM_DASH_FORMAT: 'YYYY-MM-DD HH:mm',
  /**
   *  년-월-일 시 형태의 날짜 형식
   */
  YMD_H_DASH_FORMAT: 'YYYY-MM-DD HH',
  /**
   *  년-월-일 형태의 날짜 형식
   */
  YMD_DASH_FORMAT: 'YYYY-MM-DD',
  /**
   *  년-월 형태의 날짜 형식
   */
  YM_DASH_FORMAT: 'YYYY-MM',
  /**
   *  FULL DOT 형태의 날짜 형식
   */
  FULL_DOT_FORMAT: 'YYYY.MM.DD HH:mm:ss',
  /**
   *  년.월.일 시:분 형태의 날짜 형식
   */
  YMD_HM_DOT_FORMAT: 'YYYY.MM.DD HH:mm',
  /**
   *  년.월.일 형태의 날짜 형식
   */
  YMD_DOT_FORMAT: 'YYYY.MM.DD',
  /**
   *  년.월 형태의 날짜 형식
   */
  YM_DOT_FORMAT: 'YYYY.MM',
  /**
   *  시:분 형태의 날짜 형식
   */
  HM_FORMAT: 'HH:mm',
  /**
   *  월/일 형태의 날짜 형식
   */
  MD_SLASH_FORMAT: 'MM/DD',
  /**
   *  요일 형태의 형식
   */
  DAY_OF_THE_WEEK_FORMAT: 'dddd',
  /**
   *  AM/PM 형태의 형식
   */
  AM_PM_FORMAT: 'a h',
  /**
   *  UTC 형식
   */
  UTC_FORMAT: 'YYYY-MM-DD"T"HH:mm:ss.SSS"Z"',
} as const;
export type DATE_FORMAT = ValueOf<typeof DATE_FORMAT>;
